module.exports = __webpack_public_path__ + "static/media/yellow.39c60b8c.svg";